require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./container"), require("./label"), require("./checkbox"), require("./collapse"), require("./radiogroup"), require("./textinput"), require("./toggleswitch"), require("./select"), require("./numberinput"), require("./combobox"), require("./selectgroup"), require("./textarea"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./truncatedtext", "./container", "./label", "./checkbox", "./collapse", "./radiogroup", "./textinput", "./toggleswitch", "./select", "./numberinput", "./combobox", "./selectgroup", "./textarea"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./container"), require("./label"), require("./checkbox"), require("./collapse"), require("./radiogroup"), require("./textinput"), require("./toggleswitch"), require("./select"), require("./numberinput"), require("./combobox"), require("./selectgroup"), require("./textarea")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./truncatedtext"], root["./container"], root["./label"], root["./checkbox"], root["./collapse"], root["./radiogroup"], root["./textinput"], root["./toggleswitch"], root["./select"], root["./numberinput"], root["./combobox"], root["./selectgroup"], root["./textarea"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__37__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__43__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__48__, __WEBPACK_EXTERNAL_MODULE__49__, __WEBPACK_EXTERNAL_MODULE__50__, __WEBPACK_EXTERNAL_MODULE__80__, __WEBPACK_EXTERNAL_MODULE__81__, __WEBPACK_EXTERNAL_MODULE__82__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[45],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _container = _interopRequireDefault(__webpack_require__(18));

var _label = _interopRequireDefault(__webpack_require__(19));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(408));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// TODO build out clickRelay component?
// import ClickRelay from '../controls/ClickRelay';
var propertiesPaneClassName = _PropertiesPane["default"].propertiesPaneClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

var PropertiesPane = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(PropertiesPane, _Component);

  function PropertiesPane() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PropertiesPane.prototype;

  _proto._onClick = function _onClick(labelAction) {
    return function (e) {
      labelAction && e.preventDefault();
    };
  };

  _proto._isLabelAction = function _isLabelAction() {
    var children = this.props.children;
    var labelAction;
    var child;

    try {
      child = _react["default"].Children.only(children).type; // prevent dropdown focusing on label click

      labelAction = child.__Select__ || child.__ComboBox__ || child.__SelectGroup__ || false;
    } catch (err) {
      labelAction = false;
    }

    return labelAction;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        icon = _this$props.icon,
        label = _this$props.label,
        htmlFor = _this$props.htmlFor,
        labelId = _this$props.labelId,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        dataLabel = _this$props.dataLabel,
        children = _this$props.children,
        childrenAlignEnd = _this$props.childrenAlignEnd,
        className = _this$props.className,
        style = _this$props.style,
        labelStyle = _this$props.labelStyle,
        labelSize = _this$props.labelSize,
        validationNode = _this$props.validationNode,
        descriptionNode = _this$props.descriptionNode,
        changeIndicatorNode = _this$props.changeIndicatorNode,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["icon", "label", "htmlFor", "labelId", "disabled", "rtl", "dataLabel", "children", "childrenAlignEnd", "className", "style", "labelStyle", "labelSize", "validationNode", "descriptionNode", "changeIndicatorNode"]);
    var isColumn = labelSize === 'full';

    var labelAction = this._isLabelAction();

    var iconComponent;
    var iconType = typeof icon;

    if (iconType !== 'undefined') {
      // will be deprecated
      iconComponent = /*#__PURE__*/_react["default"].createElement("span", {
        className: propertiesPaneClassName + "__iconPosition"
      }, iconType === 'string' ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        className: (0, _utils.classnames)(propertiesPaneClassName + "__icon"),
        disabled: disabled,
        iconId: icon,
        size: "small"
      }) : icon);
    }

    var labelContent = /*#__PURE__*/_react["default"].createElement("div", {
      className: propertiesPaneClassName + "__labelContent " + (0, _utils.classnames)({
        rtl: rtl
      })
    }, iconComponent, typeof label === 'string' ? /*#__PURE__*/_react["default"].createElement(_label["default"], {
      onClick: this._onClick(labelAction),
      htmlFor: htmlFor,
      label: label,
      disabled: disabled,
      ellipsis: dataLabel,
      style: labelStyle
    }) : label);

    if (validationNode || descriptionNode || changeIndicatorNode) {
      labelContent = /*#__PURE__*/_react["default"].createElement("div", {
        className: propertiesPaneClassName + "__labelContent " + (0, _utils.classnames)({
          rtl: rtl
        })
      }, validationNode, descriptionNode, typeof label === 'string' ? /*#__PURE__*/_react["default"].createElement(_label["default"], {
        onClick: this._onClick(labelAction),
        htmlFor: htmlFor,
        label: label,
        disabled: disabled,
        ellipsis: dataLabel,
        style: labelStyle
      }) : label, changeIndicatorNode);
    }

    var classNames = (0, _utils.classnames)(propertiesPaneClassName, {
      rtl: rtl
    });
    return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sanitize(others, PropertiesPane), {
      padding: [0, 0],
      className: classNames + " " + className,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_container["default"], {
      className: (0, _utils.classnames)(propertiesPaneClassName + "__inner", labelSize, isColumn ? 'column' : '')
    }, /*#__PURE__*/_react["default"].createElement(_container["default"], {
      className: (0, _utils.classnames)(propertiesPaneClassName + "__label"),
      id: labelId
    }, labelContent), /*#__PURE__*/_react["default"].createElement(_container["default"], {
      className: (0, _utils.classnames)(propertiesPaneClassName + "__children", {
        flexEnd: childrenAlignEnd
      })
    }, children)));
  };

  return PropertiesPane;
}(_react.Component);

exports["default"] = PropertiesPane;
(0, _defineProperty2["default"])(PropertiesPane, "propTypes", {
  icon: BaPropTypes.deprecated('It will be removed soon, use "validationRenderer", "descriptionRenderer", "changeRenderer" instead'),
  validationNode: _propTypes["default"].node,
  descriptionNode: _propTypes["default"].node,
  changeIndicatorNode: _propTypes["default"].node,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  htmlFor: _propTypes["default"].string,
  className: _propTypes["default"].string,
  labelId: _propTypes["default"].string,
  style: _propTypes["default"].object,
  labelStyle: _propTypes["default"].object,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  dataLabel: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  childrenAlignEnd: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(PropertiesPane, "defaultProps", {
  labelSize: 'medium',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__37__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(407);


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

exports["default"] = _PropertiesPane["default"];
exports.PropertiesPane = _PropertiesPane["default"];

var _PropertyPanel = _interopRequireDefault(__webpack_require__(410));

exports.PropertyPanel = _PropertyPanel["default"];

var _TextSection = _interopRequireDefault(__webpack_require__(413));

exports.TextSection = _TextSection["default"];

var _CheckboxSection = _interopRequireDefault(__webpack_require__(415));

exports.CheckboxSection = _CheckboxSection["default"];

var _ComboboxSection = _interopRequireDefault(__webpack_require__(416));

exports.ComboboxSection = _ComboboxSection["default"];

var _ToggleSwitchSection = _interopRequireDefault(__webpack_require__(417));

exports.ToggleSwitchSection = _ToggleSwitchSection["default"];

var _RadioSection = _interopRequireDefault(__webpack_require__(418));

exports.RadioSection = _RadioSection["default"];

var _SelectSection = _interopRequireDefault(__webpack_require__(419));

exports.SelectSection = _SelectSection["default"];

var _MultiSelectSection = _interopRequireDefault(__webpack_require__(420));

exports.MultiSelectSection = _MultiSelectSection["default"];

var _TextAreaSection = _interopRequireDefault(__webpack_require__(421));

exports.TextAreaSection = _TextAreaSection["default"];

var _TextInputSection = _interopRequireDefault(__webpack_require__(422));

exports.TextInputSection = _TextInputSection["default"];

var _NumberInputSection = _interopRequireDefault(__webpack_require__(423));

exports.NumberInputSection = _NumberInputSection["default"];

var _CollapsibleSection = _interopRequireDefault(__webpack_require__(424));

exports.CollapsibleSection = _CollapsibleSection["default"];

var _LabelSection = _interopRequireDefault(__webpack_require__(425));

exports.LabelSection = _LabelSection["default"];

var _LinkSection = _interopRequireDefault(__webpack_require__(426));

exports.LinkSection = _LinkSection["default"];

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(409);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-collapsibleSection .is-large .ba-common-propertiesPane__children{justify-content:flex-end}.ba-common-propertiesPane{min-height:40px}.ba-common-propertiesPane__inner{display:grid;width:100%;grid-gap:8px;grid-template-areas:\"ba-common-propertiesPane__label ba-common-propertiesPane__children\";grid-template-columns:1fr 1fr 1fr 1fr;-ms-grid-template-columns:1fr 8px 1fr 8px 1fr 8px 1fr}.ba-common-propertiesPane__inner.is-column{grid-gap:0;grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{justify-content:flex-start;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{justify-content:flex-start;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:1 / 2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:2 / 5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:1 / 3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:3 / 5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:1 / 4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:4 / 5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane__inner .ba-common-propertiesPane__label{display:flex;flex-direction:column}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children{display:flex;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children.is-flexEnd{justify-content:flex-end}.ba-common-propertiesPane__inner .ba-common-button:not(.is-disabled) *:hover{cursor:pointer}.ba-common-propertiesPane__inner .ba-common-button.is-disabled *:hover{cursor:not-allowed}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__children{grid-row:1;justify-content:flex-start}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column{grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{grid-row:1;justify-content:flex-end;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{grid-row:2;justify-content:flex-end;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:4 / 5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:1 / 4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:3 / 5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:1 / 3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:2 / 5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:1 / 2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__iconPosition{margin-left:8px;margin-right:0px}.ba-common-propertiesPane__iconPosition{margin-right:8px;margin-left:0px;align-items:center}.ba-common-propertiesPane__iconPosition .ba-common-propertiesPane__icon{height:32px}.ba-common-propertiesPane__labelContent{display:flex;flex-direction:row;min-height:40px;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__labelContent.is-rtl{flex-direction:row-reverse}.ba-common-propertiesPane__labelContent .ba-common-label{line-height:20px}.ba-common-propertiesPane__labelContent>*{margin-right:8px}.ba--highContrast .ba-common-propertiesPane.is-header{outline:1px inset transparent}.ba-common-propertiesPane{transition:color .2s ease-in-out;background-color:#fff}.ba-common-propertiesPane.is-header{color:#1f57a4;background-color:#f6f6f6}.ba-common-propertiesPane__icon{transition:opacity .2s ease-in-out}.ba-common-propertiesPane__icon.is-disabled{opacity:.5}\n", ""]);

// exports
exports.locals = {
	"propertiesPaneClassName": "\"ba-common-propertiesPane\""
};

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _container = _interopRequireDefault(__webpack_require__(18));

var _label = _interopRequireDefault(__webpack_require__(19));

var _utils = __webpack_require__(4);

var _PropertyPanel = _interopRequireDefault(__webpack_require__(411));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var propertyPanelClassName = _PropertyPanel["default"].propertyPanelClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

var PropertyPanel = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(PropertyPanel, _Component);

  function PropertyPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PropertyPanel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        className = _this$props.className,
        isResizable = _this$props.isResizable,
        children = _this$props.children,
        buttons = _this$props.buttons,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["title", "className", "isResizable", "children", "buttons", "style"]);

    var titleSection = /*#__PURE__*/_react["default"].createElement(_label["default"], {
      "data-tid": "ba-common-property-panel__title-section",
      className: propertyPanelClassName + "__panelTitle",
      label: title
    });

    var childrenContent = /*#__PURE__*/_react["default"].createElement(_container["default"], {
      "data-tid": "ba-common-property-panel__content-section"
    }, children);

    var buttonsSection = buttons ? /*#__PURE__*/_react["default"].createElement(_container["default"], {
      "data-tid": "ba-common-property-panel__button-section",
      className: propertyPanelClassName + "__buttonSection"
    }, buttons) : '';
    var classNames = (0, _utils.classnames)(propertyPanelClassName);
    return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sanitize(others, PropertyPanel), {
      className: classNames + " " + className,
      resizable: isResizable,
      style: style
    }), titleSection, childrenContent, buttonsSection);
  };

  return PropertyPanel;
}(_react.Component);

exports["default"] = PropertyPanel;
(0, _defineProperty2["default"])(PropertyPanel, "propTypes", {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  className: _propTypes["default"].string,
  // children:
  // Tabs -> TabPanels -> PropertySections
  // PropertySections
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].array]),
  buttons: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].array]),
  rtl: _propTypes["default"].bool,
  isResizable: _propTypes["default"].bool,
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(PropertyPanel, "defaultProps", {
  className: '',
  style: {},
  title: ''
});

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(412);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-propertyPanel{font-size:14px;display:flex;flex-direction:column;background:white;min-width:400px;padding:0 24px;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.1)}.ba-common-propertyPanel__panelTitle{line-height:48px;width:100%;font-weight:600;vertical-align:middle}.ba-common-propertyPanel .ba-common-tabList{height:40px;margin-bottom:24px}.ba-common-propertyPanel .ba-common-tabList__inner{padding:0}.ba-common-propertyPanel__buttonSection{display:flex;height:64px;align-items:center;flex-direction:row-reverse}.ba-common-propertyPanel__buttonSection__rightButton{align-self:flex-end}\n", ""]);

// exports
exports.locals = {
	"propertyPanelClassName": "\"ba-common-propertyPanel\""
};

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var textSectionClassName = _SectionStyles["default"].textSectionClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;
var omit = _utils.lodash.omit;

var TextSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TextSection, _Component);

  function TextSection() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TextSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        text = _this$props.text,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        rtl = _this$props.rtl,
        labelSize = _this$props.labelSize,
        textAlign = _this$props.textAlign,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "text", "disabled", "readOnly", "rtl", "labelSize", "textAlign", "className", "style"]);
    var classNames = (0, _utils.classnames)(textSectionClassName, rtl);
    var truncatedTextPassthroughProps = getInheritedProps(others, _truncatedtext["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, TextSection), propertiesPanePassthroughProps, {
      className: classNames + " " + className,
      label: label,
      title: title,
      rtl: rtl,
      labelSize: labelSize,
      disabled: disabled,
      style: style
    }), /*#__PURE__*/_react["default"].createElement("div", {
      "data-tid": "ba-common-text-section__truncated-text",
      className: (0, _utils.classnames)({
        disabled: disabled || readOnly
      })
    }, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], (0, _extends2["default"])({}, truncatedTextPassthroughProps, {
      value: text,
      textAlign: textAlign
    }))));
  };

  return TextSection;
}(_react.Component);

exports["default"] = TextSection;
(0, _defineProperty2["default"])(TextSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  text: _propTypes["default"].string.isRequired,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  resizable: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  truncateFullCount: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, omit(_truncatedtext["default"].propTypes, 'value'), _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(TextSection, "defaultProps", {
  truncateFullCount: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-labelSection{display:flex;align-items:center;min-height:40px;width:100%}.ba-common-labelSection .ba-common-label{font-weight:600}.ba-common-labelSection.is-sectionHeader .ba-common-label{font-weight:600}.ba-common-labelSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-labelSection .ba-common-truncatedText{text-align:right}.ba-common-textInputSection{text-align:left !important}.ba-common-textInputSection .ba-common-baseInput{height:32px}.ba-common-textInputSection .ba-common-baseInput input{height:32px}.ba-common-numberSection{text-align:left !important}.ba-common-numberSection .ba-common-baseInput{height:32px}.ba-common-numberSection .ba-common-baseInput input{height:32px}.ba-common-checkboxSection .ba-common-checkbox.is-right input{right:0}.ba-common-checkboxSection .ba-common-checkbox__box{margin-top:-2px}.ba-common-selectSection .ba-common-select{width:100%}.ba-common-selectSection .ba-common-select__wrapper{width:100%}.ba-common-selectSection .ba-common-select .ba-common-button{min-width:0}.ba-common-selectSection .ba-common-select .ba-common-toolTip{display:block !important}.ba-common-selectSection .ba-common-select .ba-common-truncatedText__text{line-height:20px}.ba-common-selectSection .ba-common-select .ba-common-selectGroup{width:100%}.ba-common-selectSection .ba-common-selectGroup{padding:4px 0;width:100%}.ba-common-linkSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-linkSection .ba-common-truncatedText{text-align:right}.ba-common-textAreaSection .ba-common-textArea>textarea{margin-top:0}.ba-common-comboboxSection .ba-common-combobox{min-width:80px !important;width:100% !important;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput{width:100%;border-left:0;border-right:0;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput input{height:32px}.ba-common-collapsibleSection .ba-common-propertiesPane:first-child{padding-top:0}.ba-common-collapsibleSection .ba-common-propertiesPane .ba-common-button:first-of-type{padding:0 8px}.ba-common-collapsibleSection__trigger-button{color:inherit;margin-right:0px;margin-top:4px;min-width:100%}.ba-common-collapsibleSection__trigger-button:hover{color:inherit}.ba-common-collapsibleSection__trigger-button.bx--btn--ghost.bx--btn--field{outline:none;padding-left:0px}.ba-common-radioSection .ba-radioGroup.is-vertical.is-right{align-items:flex-end}.ba-common-radioSection .ba-radioGroup.is-vertical.is-left{align-items:flex-start}.ba-common-radioSection .ba-radioGroup__item .ba-radio{flex-direction:row}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-left .ba-radio__label{padding-left:8px;padding-right:0}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-right .ba-radio__label{padding-right:8px;padding-left:0}.ba-common-textSection{height:20px}.ba-common-textSection .ba-common-truncatedText{text-align:right}.ba-common-textSection .ba-common-truncatedText__text{line-height:20px}.ba-common-textSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-combobox__wrapper .ba-common-combobox__icon{transition:none;color:#595859}.ba-common-textSection.is-disabled .ba-common-truncatedText{opacity:1}.ba-common-textSection.is-disabled .ba-common-truncatedText__text{opacity:.5}\n", ""]);

// exports
exports.locals = {
	"labelSectionClassName": "\"ba-common-labelSection\"",
	"textInputSectionClassName": "\"ba-common-textInputSection\"",
	"selectSectionClassName": "\"ba-common-selectSection\"",
	"textAreaSectionClassName": "\"ba-common-textAreaSection\"",
	"collapsibleSectionClassName": "\"ba-common-collapsibleSection\"",
	"radioSectionClassName": "\"ba-common-radioSection\"",
	"textSectionClassName": "\"ba-common-textSection\"",
	"checkboxSectionClassName": "\"ba-common-checkboxSection\"",
	"linkSectionClassName": "\"ba-common-linkSection\"",
	"comboboxSectionClassName": "\"ba-common-comboboxSection\"",
	"numberInputSectionClassName": "\"ba-common-numberSection\""
};

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(37));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var checkboxSectionClassName = _SectionStyles["default"].checkboxSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

var CheckboxSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CheckboxSection, _Component);

  function CheckboxSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__checkboxSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = CheckboxSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        checked = _this$props.checked,
        indeterminate = _this$props.indeterminate,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        rtl = _this$props.rtl,
        onChange = _this$props.onChange,
        labelSize = _this$props.labelSize,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "checked", "indeterminate", "disabled", "readOnly", "rtl", "onChange", "labelSize", "className", "style"]);
    var checkboxPassthroughProps = getInheritedProps(others, _checkbox["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);

    var checkbox = /*#__PURE__*/_react["default"].createElement(_checkbox["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-checkbox-section__" + this._id + "-checkbox"
    }, checkboxPassthroughProps, {
      align: rtl ? 'right' : 'left',
      checked: checked,
      indeterminate: indeterminate,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      id: this._id,
      "aria-labelledby": this._propLabelId
    }));

    var classnames = (0, _utils.classnames)(checkboxSectionClassName);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, CheckboxSection), propertiesPanePassthroughProps, {
      className: classnames + " " + className,
      label: label,
      title: title,
      labelSize: labelSize,
      labelId: this._propLabelId,
      disabled: disabled,
      htmlFor: this._id,
      rtl: rtl,
      style: style
    }), checkbox);
  };

  return CheckboxSection;
}(_react.Component);

exports["default"] = CheckboxSection;
(0, _defineProperty2["default"])(CheckboxSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  indeterminate: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _checkbox["default"].propTypes, _PropertiesPane["default"].propTypes, {
  labelSize: BaPropTypes.deprecated('It will be removed soon, Checkbox width is non-negotiable')
}));
(0, _defineProperty2["default"])(CheckboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _combobox = _interopRequireDefault(__webpack_require__(80));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var comboboxSectionClassName = _SectionStyles["default"].comboboxSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var ComboboxSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ComboboxSection, _Component);

  function ComboboxSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__ComboboxSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = ComboboxSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        labelSize = _this$props.labelSize,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "labelSize", "disabled", "rtl", "className", "style"]);
    var comboBoxPassthroughProps = getInheritedProps(others, _combobox["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, ComboboxSection), propertiesPanePassthroughProps, {
      className: comboboxSectionClassName + " " + className,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      label: label,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_combobox["default"], (0, _extends2["default"])({
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-combox-section__combox",
      disabled: disabled
    }, comboBoxPassthroughProps)));
  };

  return ComboboxSection;
}(_react.Component);

exports["default"] = ComboboxSection;
(0, _defineProperty2["default"])(ComboboxSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _combobox["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(ComboboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _toggleswitch = _interopRequireDefault(__webpack_require__(48));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var ToggleSwitchSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ToggleSwitchSection, _Component);

  function ToggleSwitchSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__toggleSwitchSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = ToggleSwitchSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        rtl = _this$props.rtl,
        onChange = _this$props.onChange,
        className = _this$props.className,
        style = _this$props.style,
        small = _this$props.small,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "checked", "disabled", "readOnly", "rtl", "onChange", "className", "style", "small"]);
    var toggleSwitchPassthroughProps = getInheritedProps(others, _toggleswitch["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, ToggleSwitchSection), propertiesPanePassthroughProps, {
      className: className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_toggleswitch["default"], (0, _extends2["default"])({
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-toggleswitch-section__toggleswitch"
    }, toggleSwitchPassthroughProps, {
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      small: small != null ? small : true
    })));
  };

  return ToggleSwitchSection;
}(_react.Component);

exports["default"] = ToggleSwitchSection;
(0, _defineProperty2["default"])(ToggleSwitchSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _toggleswitch["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(ToggleSwitchSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _radiogroup = _interopRequireDefault(__webpack_require__(43));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var radioSectionClassName = _SectionStyles["default"].radioSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var RadioSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(RadioSection, _Component);

  function RadioSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__radioSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = RadioSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        rtl = _this$props.rtl,
        options = _this$props.options,
        onChange = _this$props.onChange,
        labelSize = _this$props.labelSize,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "checked", "disabled", "readOnly", "rtl", "options", "onChange", "labelSize", "className", "style"]);
    var align = this.props.align || rtl ? 'right' : 'left';
    var radioGroupPassthroughProps = getInheritedProps(others, _radiogroup["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others), propertiesPanePassthroughProps, {
      className: radioSectionClassName + " " + className,
      labelSize: labelSize,
      label: label,
      title: title,
      disabled: disabled,
      rtl: rtl,
      htmlFor: this._id,
      labelId: this._propLabelId,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_radiogroup["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-radio-section__radio-group",
      "aria-labelledby": this._propLabelId
    }, radioGroupPassthroughProps, {
      selectedId: this._id,
      direction: "vertical",
      align: align,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options
    })));
  };

  return RadioSection;
}(_react.Component);

exports["default"] = RadioSection;
(0, _defineProperty2["default"])(RadioSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(['left', 'right']),
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes["default"].array.isRequired,
  checked: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _radiogroup["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(RadioSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _select = _interopRequireDefault(__webpack_require__(49));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var selectSectionClassName = _SectionStyles["default"].selectSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var SelectSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SelectSection, _Component);

  function SelectSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__selectSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = SelectSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        selected = _this$props.selected,
        options = _this$props.options,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        textDir = _this$props.textDir,
        onChange = _this$props.onChange,
        readOnly = _this$props.readOnly,
        labelSize = _this$props.labelSize,
        displayLabel = _this$props.displayLabel,
        className = _this$props.className,
        style = _this$props.style,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "selected", "options", "disabled", "rtl", "textDir", "onChange", "readOnly", "labelSize", "displayLabel", "className", "style", "light"]);
    var selectPassthroughProps = getInheritedProps(others, _select["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, SelectSection), propertiesPanePassthroughProps, {
      className: selectSectionClassName + " " + className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_select["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-select-section__select",
      "aria-labelledby": this._propLabelId
    }, sanitize(selectPassthroughProps, null, 'icon'), {
      // {...selectPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      size: "small",
      id: this._id,
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      displayLabel: displayLabel,
      options: options,
      textDir: textDir,
      light: light != null ? light : true
    })));
  };

  return SelectSection;
}(_react.Component);

exports["default"] = SelectSection;
(0, _defineProperty2["default"])(SelectSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  displayLabel: _propTypes["default"].string,
  // Used for empty placeholder state of select. Will not be shown if passed a Selected prop
  title: _propTypes["default"].string,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  // CSS Grid layout 1/4, 1/2, 3/4, full widths
  selected: _propTypes["default"].any.isRequired,
  options: _propTypes["default"].array.isRequired,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  onChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _select["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(SelectSection, "defaultProps", {
  className: '',
  style: {},
  selected: []
});

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _selectgroup = _interopRequireDefault(__webpack_require__(81));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var selectSectionClassName = _SectionStyles["default"].selectSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var SelectGroupSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SelectGroupSection, _Component);

  function SelectGroupSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__multiSelectSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = SelectGroupSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        options = _this$props.options,
        label = _this$props.label,
        title = _this$props.title,
        selected = _this$props.selected,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        rtl = _this$props.rtl,
        onChange = _this$props.onChange,
        labelSize = _this$props.labelSize,
        className = _this$props.className,
        style = _this$props.style,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["options", "label", "title", "selected", "disabled", "readOnly", "rtl", "onChange", "labelSize", "className", "style", "light"]);
    var selectGroupPassthroughProps = getInheritedProps(others, _selectgroup["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, SelectGroupSection), propertiesPanePassthroughProps, {
      className: selectSectionClassName + " " + className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_selectgroup["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-select-group-section__select-group",
      "aria-labelledby": this._propLabelId
    }, sanitize(selectGroupPassthroughProps, null, 'icon'), {
      // {...selectGroupPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      lastId: this._id,
      size: "small",
      align: rtl ? 'left' : 'right',
      orient: rtl ? 'bottom-right' : 'bottom-left',
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options,
      light: light != null ? light : true
    })));
  };

  return SelectGroupSection;
}(_react.Component);

exports["default"] = SelectGroupSection;
(0, _defineProperty2["default"])(SelectGroupSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes["default"].object.isRequired,
  selected: _propTypes["default"].array.isRequired,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _selectgroup["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(SelectGroupSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _textarea = _interopRequireDefault(__webpack_require__(82));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var textAreaSectionClassName = _SectionStyles["default"].textAreaSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars


var TextAreaSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TextAreaSection, _Component);

  function TextAreaSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__textAreaSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = TextAreaSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        placeholder = _this$props.placeholder,
        rows = _this$props.rows,
        value = _this$props.value,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        fireOnBlur = _this$props.fireOnBlur,
        onChange = _this$props.onChange,
        readOnly = _this$props.readOnly,
        className = _this$props.className,
        labelSize = _this$props.labelSize,
        style = _this$props.style,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "title", "placeholder", "rows", "value", "disabled", "rtl", "fireOnBlur", "onChange", "readOnly", "className", "labelSize", "style", "light"]);
    var classNames = (0, _utils.classnames)(textAreaSectionClassName);
    var textAreaPassthroughProps = getInheritedProps(others, _textarea["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, TextAreaSection), propertiesPanePassthroughProps, {
      className: classNames + " " + className,
      label: label,
      title: title,
      disabled: disabled,
      labelSize: labelSize,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_textarea["default"], (0, _extends2["default"])({
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-textarea-section__textarea"
    }, textAreaPassthroughProps, {
      id: this._id,
      value: value,
      rows: rows,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      placeholder: placeholder,
      fireOnBlur: fireOnBlur,
      light: light != null ? light : true
    })));
  };

  return TextAreaSection;
}(_react.Component);

exports["default"] = TextAreaSection;
(0, _defineProperty2["default"])(TextAreaSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  className: _propTypes["default"].string,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  rows: _propTypes["default"].number,
  fireOnBlur: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object
}, _textarea["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(TextAreaSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _textinput = _interopRequireDefault(__webpack_require__(47));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var textInputSectionClassName = _SectionStyles["default"].textInputSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var TextInputSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TextInputSection, _Component);

  function TextInputSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__textInputSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = TextInputSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        dataTid = _this$props['data-tid'],
        label = _this$props.label,
        title = _this$props.title,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        textAlign = _this$props.textAlign,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        fireOnBlur = _this$props.fireOnBlur,
        onChange = _this$props.onChange,
        readOnly = _this$props.readOnly,
        labelSize = _this$props.labelSize,
        className = _this$props.className,
        style = _this$props.style,
        textDir = _this$props.textDir,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["data-tid", "label", "title", "placeholder", "value", "textAlign", "disabled", "rtl", "fireOnBlur", "onChange", "readOnly", "labelSize", "className", "style", "textDir", "light"]);
    var textInputPassthroughProps = getInheritedProps(others, _textinput["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    var inputProps = {
      id: this._id,
      fullWidth: true,
      textAlign: textAlign,
      placeholder: placeholder,
      value: value,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      fireOnBlur: fireOnBlur
    };
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, TextInputSection), propertiesPanePassthroughProps, {
      "data-tid": dataTid,
      className: textInputSectionClassName + " " + className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_textinput["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-textinput-section__textinput",
      "aria-labelledby": this._propLabelId // {...textInputPassthroughProps}// TODO: uncomment this line and remove the next two lines when icon is deprecated

    }, sanitize(textInputPassthroughProps, null, 'icon'), {
      textDir: textDir
    }, inputProps, {
      className: "textInputSection",
      light: light != null ? light : true
    })));
  };

  return TextInputSection;
}(_react.Component);

exports["default"] = TextInputSection;
(0, _defineProperty2["default"])(TextInputSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  textAlign: _propTypes["default"].oneOf(['left', 'right']),
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  fireOnBlur: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _textinput["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(TextInputSection, "defaultProps", {
  textAlign: 'left',
  className: '',
  style: {}
});

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _numberinput = _interopRequireDefault(__webpack_require__(50));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var numberInputSectionClassName = _SectionStyles["default"].numberInputSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var NumberInputSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(NumberInputSection, _Component);

  function NumberInputSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__numberInputSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = NumberInputSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        light = _this$props.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["title", "light"]);
    var numberInputPassthroughProps = getInheritedProps(others, _numberinput["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    var inputProps = {
      id: this._id,
      fullWidth: true
    };
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, propertiesPanePassthroughProps, {
      title: title,
      htmlFor: this._id,
      labelId: this._propLabelId,
      className: "" + numberInputSectionClassName
    }), /*#__PURE__*/_react["default"].createElement(_numberinput["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-numberinput-section__numberinput",
      "aria-labelledby": this._propLabelId // {...numberInputPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated

    }, sanitize(numberInputPassthroughProps, null, 'icon'), inputProps, {
      className: "numberInputSection",
      light: light != null ? light : true
    })));
  };

  return NumberInputSection;
}(_react.Component);

exports["default"] = NumberInputSection;
(0, _defineProperty2["default"])(NumberInputSection, "propTypes", (0, _extends2["default"])({
  title: _propTypes["default"].string
}, sanitize(_numberinput["default"].propTypes, null, 'fullWidth'), _PropertiesPane["default"].propTypes));

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _button = _interopRequireDefault(__webpack_require__(15));

var _collapse = _interopRequireDefault(__webpack_require__(42));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _chevronRight_ = _interopRequireDefault(__webpack_require__(61));

var _container = _interopRequireDefault(__webpack_require__(18));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var collapsibleSectionClassName = _SectionStyles["default"].collapsibleSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars


var uniqueId = _utils.lodash.uniqueId,
    omit = _utils.lodash.omit;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames;

var CollapsibleSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CollapsibleSection, _Component);

  function CollapsibleSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_toggleOpen", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          onOpen = _this$props.onOpen;

      if (typeof open === 'undefined') {
        _this.setState({
          open: !_this.state.open
        });
      }

      onOpen && onOpen(!open);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var open = _this.state.open;

      switch (getKeyName(e)) {
        case keyNames.LEFT:
        case keyNames.UP:
          e.preventDefault();

          if (open) {
            _this._toggleOpen();
          }

          break;

        case keyNames.RIGHT:
        case keyNames.DOWN:
          e.preventDefault();

          if (!open) {
            _this._toggleOpen();
          }

          break;

        default:
      }
    });
    _this.state = {
      open: !!_this.props.defaultOpen || !!_this.props.open
    };
    _this._id = uniqueId('__collapsibleSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = CollapsibleSection.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var open = _ref.open;

    if (open != null && open !== this.state.open) {
      this.setState({
        open: open
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        label = _this$props2.label,
        title = _this$props2.title,
        rtl = _this$props2.rtl,
        variant = _this$props2.variant,
        children = _this$props2.children,
        className = _this$props2.className,
        style = _this$props2.style,
        labelStyle = _this$props2.labelStyle,
        autoUnmount = _this$props2.autoUnmount,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["label", "title", "rtl", "variant", "children", "className", "style", "labelStyle", "autoUnmount"]);
    var open = this.state.open;
    var regionId = this._id + "_region";
    var collapsePassthroughProps = getInheritedProps(others, _collapse["default"]);
    var buttonPassthoughProps = getInheritedProps(others, _button["default"]);
    var propertiesPanePassthoughProps = getInheritedProps(others, _PropertiesPane["default"]);

    var labelNode = /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-collapse-section__trigger-button",
      className: collapsibleSectionClassName + "__trigger-button"
    }, buttonPassthoughProps, {
      id: this._id,
      kind: "ghost",
      size: "field",
      renderIcon: function renderIcon(props) {
        return /*#__PURE__*/_react["default"].createElement(_svgicon["default"], (0, _extends2["default"])({
          icon: _chevronRight_["default"],
          rotate: open ? -90 : 90
        }, props));
      },
      onClick: this._toggleOpen,
      onKeyDown: this._onKeyDown,
      "aria-controls": regionId,
      "aria-expanded": open,
      "aria-labelledby": this._propLabelId,
      style: labelStyle
    }), label);

    return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sanitize(others, CollapsibleSection), {
      className: "ba-common-collapsibleSection " + className,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, propertiesPanePassthoughProps, {
      label: labelNode,
      title: title,
      rtl: rtl,
      htmlFor: this._id,
      labelSize: "full",
      labelId: this._propLabelId,
      variant: variant
    })), /*#__PURE__*/_react["default"].createElement(_collapse["default"], (0, _extends2["default"])({}, collapsePassthroughProps, {
      autoUnmount: autoUnmount,
      isOpened: open,
      id: regionId
    }), children));
  };

  return CollapsibleSection;
}(_react.Component);

exports["default"] = CollapsibleSection;
(0, _defineProperty2["default"])(CollapsibleSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string,
  defaultOpen: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['normal', 'header']),
  onOpen: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  labelStyle: _propTypes["default"].object,
  autoUnmount: _propTypes["default"].bool
}, omit(_collapse["default"].propTypes, 'isOpened')));
(0, _defineProperty2["default"])(CollapsibleSection, "defaultProps", {
  variant: 'normal',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _label = _interopRequireDefault(__webpack_require__(19));

var _container = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(4);

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var labelSectionClassName = _SectionStyles["default"].labelSectionClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var LabelSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(LabelSection, _Component);

  function LabelSection() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = LabelSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        rtl = _this$props.rtl,
        isSectionHeader = _this$props.isSectionHeader,
        disabled = _this$props.disabled,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "rtl", "isSectionHeader", "disabled", "className", "style"]);
    var classNames = (0, _utils.classnames)(labelSectionClassName, isSectionHeader ? 'sectionHeader' : '');
    var labelPassthroughProps = getInheritedProps(others, _label["default"]);
    return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({
      className: classNames + " " + className,
      textAlign: rtl ? 'left' : 'right',
      style: style
    }, sanitize(others, LabelSection)), /*#__PURE__*/_react["default"].createElement(_label["default"], (0, _extends2["default"])({}, labelPassthroughProps, {
      label: label,
      disabled: disabled
    })));
  };

  return LabelSection;
}(_react.Component);

exports["default"] = LabelSection;
(0, _defineProperty2["default"])(LabelSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  isSectionHeader: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _label["default"].propTypes));
(0, _defineProperty2["default"])(LabelSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _button = _interopRequireDefault(__webpack_require__(15));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _chevronRight_ = _interopRequireDefault(__webpack_require__(83));

var _SectionStyles = _interopRequireDefault(__webpack_require__(23));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(22));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var linkSectionClassName = _SectionStyles["default"].linkSectionClassName.replace(/"/g, '');

var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var LinkSection = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(LinkSection, _Component);

  function LinkSection(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this._id = uniqueId('__linkSection_');
    _this._propLabelId = _this._id + "_propLabel_";
    return _this;
  }

  var _proto = LinkSection.prototype;

  _proto.render = function render() {
    var _buttonIcon;

    var _this$props = this.props,
        label = _this$props.label,
        value = _this$props.value,
        title = _this$props.title,
        disabled = _this$props.disabled,
        rtl = _this$props.rtl,
        dataLabel = _this$props.dataLabel,
        onClick = _this$props.onClick,
        labelSize = _this$props.labelSize,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["label", "value", "title", "disabled", "rtl", "dataLabel", "onClick", "labelSize", "className", "style"]);
    var buttonIcon = (_buttonIcon = {}, _buttonIcon[rtl ? 'iconLeft' : 'iconRight'] = rtl ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      focusable: false,
      iconId: _chevronRight_["default"].id,
      rotate: 180
    }) : /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      focusable: false,
      iconId: _chevronRight_["default"].id
    }), _buttonIcon);
    var buttonPassthroughProps = getInheritedProps(others, _button["default"]);
    var propertiesPanePassthroughProps = getInheritedProps(others, _PropertiesPane["default"]);
    return /*#__PURE__*/_react["default"].createElement(_PropertiesPane["default"], (0, _extends2["default"])({}, sanitize(others, LinkSection), propertiesPanePassthroughProps, {
      className: linkSectionClassName + " " + className,
      label: label,
      rtl: rtl,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      dataLabel: dataLabel,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      role: "link",
      "data-tid": "ba-common-link-section__button-link",
      "aria-label": title // {...buttonPassThroughProps}}// TODO: uncomment this line and remove next line when icon is deprecated

    }, sanitize(buttonPassthroughProps, null, 'icon'), buttonIcon, {
      intent: "primary",
      ellipsis: true,
      id: this._id,
      variant: "inline",
      label: value,
      disabled: disabled,
      onClick: onClick,
      title: title,
      "aria-labelledby": title ? null : this._propLabelId
    })));
  };

  return LinkSection;
}(_react.Component);

exports["default"] = LinkSection;
(0, _defineProperty2["default"])(LinkSection, "propTypes", (0, _extends2["default"])({
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string,
  labelSize: _propTypes["default"].oneOf(['small', 'medium', 'large', 'full']),
  title: _propTypes["default"].string,
  // todo
  // currently title is used for the title of the link
  // we may need two titles - one for the property, and one for the link
  disabled: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  dataLabel: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}, _button["default"].propTypes, _PropertiesPane["default"].propTypes));
(0, _defineProperty2["default"])(LinkSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__43__;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__49__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__50__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-right_16");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__80__;

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__81__;

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__82__;

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-right_16.js");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[406,0]]]);
});